// Author Liang Gang Qiang
// Date 2021-10-29 09:49:47

import * as model from "@/model/em/admin/ImfMstLocationTagLoctModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.ImfMstLocationTagLoct(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
    })
    .buildStore()
